// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardAggregations_root____3br","grid":"DashboardAggregations_grid__yvyvf"};